// extracted by mini-css-extract-plugin
export default {"sideMenuHeader":"SideMenu_sideMenuHeader__FEVs4"};